import { t } from "@lingui/macro";
import { I18n } from "@lingui/core";

import { FieldName } from "..";

export default (i18n: I18n) => ({
  iban: {
    name: FieldName.iban,
    label: "IBAN",
    placeholder: `${i18n._(
      t({
        id: "placeholder.example",
        message: "e.g.",
      })
    )} GB60 BARC 2000 0055 7799 11`,
    instructions: i18n._(
      t({
        id: "fields-config.iban.instructions",
        message: "International Bank Account Number",
      })
    ),
  },
  local: [
    {
      name: FieldName.branchCode,
      label: "Sort code",
      placeholder: `${i18n._(
        t({
          id: "placeholder.example",
          message: "e.g.",
        })
      )} 10 - 20 - 30`,
      instructions: i18n._(
        t({
          id: "fields-config.branch-code.instructions.GB",
          message: "Must be 6 digits long",
        })
      ),
      pattern: /^([0-9\s-])+$/,
      formatterOptions: {
        maxLength: 6,
        onlyNumbers: true,
        parts: [2, 2, 2],
        delimiter: " - ",
      },
    },
    {
      name: FieldName.accountNumber,
      label: "Account number",
      placeholder: `${i18n._(
        t({
          id: "placeholder.example",
          message: "e.g.",
        })
      )} 12345678`,
      instructions: i18n._(
        t({
          id: "fields-config.account-number.instructions.GB",
          message: "Must be 8 digits long",
        })
      ),
      pattern: /^([0-9])+$/,
      formatterOptions: {
        maxLength: 8,
        onlyNumbers: true,
      },
    },
  ],
  primaryBankDetailsFields: [FieldName.branchCode, FieldName.accountNumber],
  secondaryBankDetailsField: [FieldName.iban],
});
